<template>
  <!-- 安祥禪曲 -->
  <div class="zenMusic" v-if="content1.length">
    <!-- 第一列 -->
    <div class="title1">{{content.cate_name}}</div>
    <div class="itemTitle">
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">{{$t('songNane')}}</div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-light">{{$t('songStyle')}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="music" v-for="(item,index) in content.lists" :key="'a'+index">
      <!-- <div class="title">{{content.cate_name}}</div> -->
     
      <div class="itemList" >
        <!-- {{item}} -->
        <el-row v-if="item">
          <el-col :span="8">
            <div class="grid-content bg-purple ">{{item.name}}</div>
          </el-col>
          <el-col :span="16" class="flex-start-wrap">
            <div class="itemStyle" v-for="(item1,index1) in item.data" :key="'next'+index1" @click="linkToSongDetail(item1)">
              <div v-if="item1">
                {{item1.class}}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <barF5></barF5>
    <!-- 后边列数 -->
    <div class="music" v-for="(item,index) in content1" :key="'b'+index">
      <div class="title">{{item.cate_name}}</div>

     
        <el-row >
          <el-col :span="24" class="flex-start-wrap" >
            <div class="itemList itemStyle1"  v-for="(item1,index1) in item.lists" :key="'next1'+index1"   @click="linkToSongDetail(item1.data[0])">
            {{item1.name}}
          </div>
            <!-- <div class="itemStyle1" v-for="(item2,index2) in item1.audio_type" :key="index2"
              @click="linkToSongDetail(item2)">{{item2}}</div> -->
          </el-col>
        </el-row>
      
      <!-- <barF5></barF5> -->
    </div>

    <!-- <barF5></barF5> -->
    <!-- <div class="note itemTitle">
      <div>{{$t('noteInfo').title1}}{{$t('noteInfo').info1}}</div>
      <div class="mt1">{{$t('noteInfo').info2}}</div>
      <div class="mt1">{{$t('noteInfo').info3}} </div>
      <div class="mt1">{{$t('noteInfo').title2}}  {{$t('noteInfo').info4}}</div>
    </div> -->
    <div style="width:3rem"></div>
  </div>
</template>

<script>
  import { getCateList, getAudioList } from "../../api/apis";
  // import {getNavName} from '../../common/js/common.js';
  import barF5 from "../../components/barF5"; //空隙bar
  export default {
    name: "",
    components: {
      barF5
    },
    props: {},
    data() {
      return {
        name:'',
        content: [
          {
          cate_name: "耕雲導師作詞或作曲",
          id:'',
          lists: [
            // {
            //   id: 1,
            //   audio_title: "合唱",
            //   audio_type: ["合唱1", "合唱2", "合唱3", "合唱4"]
            // },
            // {
            //   id: 1,
            //   audio_title: "合唱",
            //   audio_type: ["合唱1", "合唱2", "合唱3", "合唱4"]
            // },
            // {
            //   id: 1,
            //   audio_title: "合唱",
            //   audio_type: ["合唱1", "合唱2", "合唱3", "合唱4"]
            // }
          ]
        }
      ],
        content1: [
          // {
          //   cate_name: "耕雲導師作詞或作曲",
          //   lists: [{
          //       id: 1,
          //       audio_title: "合唱",
          //       audio_type: ["合唱1", "合唱2", "合唱3"]
          //     },
          //     {
          //       id: 1,
          //       audio_title: "合唱",
          //       audio_type: ["合唱1", "合唱2", "合唱3"]
          //     }
          //   ]
          // },
          // {
          //   cate_name: "紀念耕雲導師音樂會演唱曲 (圓寂三週年)",
          //   lists: [{
          //       id: 1,
          //       audio_title: "合唱",
          //       audio_type: ["合唱1", "合唱2", "合唱3","合唱1", "合唱2", "合唱3"]
          //     },
          //     {
          //       id: 1,
          //       audio_title: "合唱",
          //       audio_type: ["合唱1", "合唱2", "合唱3"] 
          //     }
          //   ]
          // }
        ]
      };
    },
    methods: {
      changShowList(index) {
        this.contentStatus.splice(index, 1, !this.contentStatus[index]);
      },
      //歌曲详情
      linkToSongDetail(item) {
	
        this.$router.push({path:'/musicDetail',query:{title:this.name,id:item.id}})
      }
  
      
    },
    created() {
        // this.length2 = this.getLength(this.list2 || [{}]);
        // this.list1 = this.initData(this.list1);
        // this.length1 = this.list1.length;

        getCateList().then(res => {
            let id = res[1][6].id;
			// this.name = res[1][6].cate_name;
			this.name = res[1][6].j_name;//cate_name繁体，j_name简体
            getAudioList(id).then(res => {
                // this.list1 = res.slice(0,1);
                if(Array.isArray(res[0].lists)){
                    this.content=res[0];
                  
                }else{
                    this.content=[{}];
                }
              
                // this.length1 = this.getLength(this.content1 || [{}]);
                this.content1 = res.slice(1);
              
            });
        });
    }
  };
</script>

<style scoped>
  .zenMusic {
    font-size: 0.8rem;
     font-size: 0.85rem;
    color: #333333;
  }

  .music .title {
    padding: 1rem 0.64rem 0.4rem 0.64rem;
    font-weight: bold;
  }
  .title1{
    padding: 1rem 0.64rem 0.4rem 0.64rem;
    font-weight: bold;
  }

  .itemTitle {
    padding: 0.64rem;
  }

  .itemList {
    border-top: 1px dashed #dfdfdf;
    padding: 0.3rem 0.64rem;
    line-height: 1.4rem;
  }

  .itemStyle {
    width: 3.73rem;
    color: #047bcd;
  }

  .itemStyle1 {
    width: 5rem;  /* 6rem*/
    color: #047bcd;
  }

  .note {
    /* font-size: 0.69rem; */
    font-size: 0.85rem;
    color: #333333;
    padding: 0.64rem;
    line-height: 1.4rem;
  }

  .mt1 {
    margin-top: 1rem;
  }
</style>